<div class="ui-task-item" (click)="taskClick.emit()">
  <div class="ui-task-item__main">
    <div class="ui-task-item__header">
      <span class="ui-task-item__title">{{ title() }}</span>
      <button type="button" class="ui-task-item__toggle" aria-label="Expandir tarea">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
    </div>

    @if (timeRange()) {
      <span class="ui-task-item__time">{{ timeRange() }}</span>
    }

    @if (participants().length) {
      <ui-avatar-group
        class="ui-task-item__participants"
        [participants]="participants()"
        [maxAvatars]="maxAvatars()"
      />
    }

    @if (platform() || tag()) {
      <div class="ui-task-item__footer">
        @if (platform()) {
          <span class="ui-task-item__platform">{{ platform() }}</span>
        }
        @if (tag()) {
          <ui-tag [label]="tag()!.label" [color]="tag()!.color" />
        }
      </div>
    }
  </div>
</div>
